module.exports = __webpack_public_path__ + "static/media/tools-zoom.d8788a62.svg";